import * as UFE from '../UFE'
import * as plume from '@ulule/owl-kit-components/next'

export const FOOTER_BREAKPOINT = UFE.LOCALE === 'fr' ? plume.BREAKPOINTS.LAPTOP : plume.BREAKPOINTS.TABLET
